import { render, staticRenderFns } from "./ImageTextContent.vue?vue&type=template&id=68bc09be&scoped=true"
import script from "./ImageTextContent.vue?vue&type=script&lang=js"
export * from "./ImageTextContent.vue?vue&type=script&lang=js"
import style0 from "./ImageTextContent.vue?vue&type=style&index=0&id=68bc09be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bc09be",
  null
  
)

export default component.exports